<template>
  <div class="companies-page">
    <div class="companies-page_container">
      <div class="header">
        简报列表
      </div>
      <bulletin-list></bulletin-list>
    </div>
  </div>
</template>

<script>
import BulletinList from '@/components/news-monitor/BulletinList';

export default {
  components: {
    BulletinList
  }
};
</script>

<style lang="scss" scoped>
.companies-page{
  width: 100%;
  min-height: 100%;
  background: #333138;
  &_container{
    width: 1048px;
    margin: 0 auto;
    padding:24px;
    .header{
      display: block;
      margin-bottom:20px;
      color:#ffffff;
      font-size:24px;
      font-family: 'DIN-Bold' sans-serif;
    }
  }
}
</style>



